import { UnleashClient } from 'unleash-proxy-client';
export class FlagsUnleashStrategy {
    /**
     * @param config Unleash client configuration.
     */
    constructor(config) {
        this.config = config;
        this.unleash = new UnleashClient(this.config);
    }
    /**
     * Initialize client.
     */
    init() {
        // Start the background polling
        return this.unleash.start();
    }
    /**
     * Feature is enabled.
     * @param name Feature name.
     */
    isEnabled(name) {
        return this.unleash.isEnabled(name);
    }
    /**
     * Update client.
     * @param config Unleash dynamic config.
     */
    update(config) {
        // Update mutable context
        return this.unleash.updateContext(config);
    }
}
